import { EmptyValueDash } from './EmptyValueDash';
import { LatestPaymentReferenceLink } from './LatestPaymentReferenceLink';
import { displayCurrency } from '../../../../../utils/DisplayCurrency';
import { CustomerRow } from '../../../CustomersV2.types';

export const LatestPaymentCell = ({ row }: { row: CustomerRow }) => {
  const payment = row.latest_payment;

  if (!payment) {
    return (
      <EmptyValueDash
        row={row}
        reason="This customer hasn't spent any of their limit yet."
      />
    );
  }

  return (
    <div className="flex flex-col">
      <span>{displayCurrency(payment.amount)}</span>
      <LatestPaymentReferenceLink reference={payment.reference} />
    </div>
  );
};
